export function ImpactHighlights() {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 to-gray-800 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img 
          src="https://hurley-associates.com/web/images/pano-pgbeach-1-700.jpg"
          alt="Beach background"
          className="w-full h-full object-cover object-center"
        />
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold mb-4">
            Our Impact
          </h2>
          <p className="text-lg text-white/80 max-w-2xl mx-auto">
            Decades of excellence in St. Pete Beach real estate
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-5xl md:text-6xl font-bold text-teal-400 mb-3">50+</div>
            <div className="text-base text-white/80">Years of Service</div>
          </div>
          <div className="text-center">
            <div className="text-5xl md:text-6xl font-bold text-teal-400 mb-3">1000+</div>
            <div className="text-base text-white/80">Properties Sold</div>
          </div>
          <div className="text-center">
            <div className="text-5xl md:text-6xl font-bold text-teal-400 mb-3">500+</div>
            <div className="text-base text-white/80">Rental Placements</div>
          </div>
          <div className="text-center">
            <div className="text-5xl md:text-6xl font-bold text-teal-400 mb-3">98%</div>
            <div className="text-base text-white/80">Client Satisfaction</div>
          </div>
        </div>
      </div>
    </section>
  );
}